import { render, staticRenderFns } from "./bidding-records.vue?vue&type=template&id=70c30253&scoped=true"
import script from "./bidding-records.vue?vue&type=script&lang=js"
export * from "./bidding-records.vue?vue&type=script&lang=js"
import style0 from "./bidding-records.vue?vue&type=style&index=0&id=70c30253&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c30253",
  null
  
)

export default component.exports